import React from 'react'
import PropTypes from 'prop-types'
import injectStyles from 'react-jss'

import ChartIcon from '../../../Assets/Images/icons/chart'
import styles from '../styles'
import WSConnectionIndicator from '../../../Components/WSConnectionIndicator/WSConnectionIndicator'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import SubmitButton from 'Components/Form/SubmitButton'

const ChatView = ({
  children,
  classes,
  toggleArchivedConversations,
  showingArchivedConversations,
  setIsSpyChat,
  isSpyChat,
}) => {
  return (
    <section className={classes.chatWrapper}>
      <header className={classes.chatHeader}>
        <div className={classes.iconTitleBlock}>
          <ChartIcon />
          <h5 className={classes.chatHeaderTitle}>Chat</h5>
        </div>
        <div className={classes.rightBlock}>
          <WSConnectionIndicator />
          <ButtonGroup
            disableElevation
            color="primary"
            className={classes.spacedBlock}
          >
            <SubmitButton
              value="All chats"
              variant={!isSpyChat ? 'contained' : 'outlined'}
              onClick={() => setIsSpyChat(false)}
            />
            <SubmitButton
              value="Spy report chats"
              variant={isSpyChat ? 'contained' : 'outlined'}
              onClick={() => setIsSpyChat(true)}
            />
          </ButtonGroup>
          <button
            onClick={toggleArchivedConversations}
            className={classes.chatHeaderButton}
            cypress_id={'chatViewHeaderBtn'}
          >
            {showingArchivedConversations
              ? 'Show Active Conversations'
              : 'Show Archived Conversations'}
          </button>
        </div>
      </header>
      <section className={classes.chatMain}>{children}</section>
    </section>
  )
}

ChatView.propTypes = {
  children: PropTypes.array,
  classes: PropTypes.object,
}

export default injectStyles(styles)(ChatView)
